import {CustomEventHandler} from "../utils/CustomEventHandler";
import {isMobile, scrollSetting} from "../common/globalVars";

export default class MotionStickyResize {
    constructor(sectionEl, nextSectionEl) {
        this.sectionEl = sectionEl;
        this.stickyEl =  sectionEl.querySelector('.sticky-holder');
        this.lineHolderEl = sectionEl.querySelector('.line-holder');
        this.posBoxEl = sectionEl.querySelector('.pos-box');
        this.nextSectionEl = nextSectionEl;

        this.onResizeHandler();
        CustomEventHandler.addHandler(window, 'resize', (e)=>this.onResizeHandler());
    }

    onResizeHandler() {
        // if (isMobile(window.innerWidth)) {
        //     this.nextSectionEl.style.paddingTop = `100px`;
        //     this.stickyEl.style.top = `-50px`;
        // } else {
            const winHeight = window.innerHeight;
            let lineHolderHeight = parseInt(window.getComputedStyle(this.lineHolderEl).height);
            let sectionElHeight =  parseInt(window.getComputedStyle(this.sectionEl).height);
            let top = lineHolderHeight - winHeight;

            if (top<0) {
                top = 0;
            }
            this.nextSectionEl.style.paddingTop = `${top + 100}px`;
            top = (top / 2) * -1;

            if (!scrollSetting.smooth) {
                this.stickyEl.style.top = `${top}px`;
            }
        // }
    }
}
